<template>
    <div
        ref="wrapper"
        :class="{
            [theme.wrapper]: true,
            'justify-content-end': config.buttons_location === 'top-right',
        }"
        class="d-flex"
    >
        <button
            v-for="(button, index) in data.config.buttons"
            :key="`button-${index}`"
            class="btn btn-default"
            :class="theme.entry"
            :dusk="button.dusk"
            @click.stop="buttonClick(button)"
        >
            <i v-if="button.icon" :class="button.icon" />
            <div v-if="button.label" v-text="button.label" />
        </button>

        <div v-if="config.menu_enabled" class="dropdown ml-1" :class="theme.optionsMenu">
            <a data-toggle="dropdown" href="javascript:void(0);">
                <button type="button" class="btn btn-default">
                    <i class="fa-solid fa-cog"></i>
                </button>
            </a>

            <div class="dropdown-menu dropdown-menu-right mt-3">
                <a
                    v-for="option in config.menu_options"
                    :key="`menu-option-${option.label}`"
                    class="dropdown-item"
                    :href="option.href ? option.href : 'javascript:void(0);'"
                    @click="menuOptionClicked(option)"
                >
                    <i :class="option.icon" />
                    {{ option.label }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Common from './mixins/Common.vue';
import UsesBindRelations from './mixins/UsesBindRelations.vue';
import { loadPanel } from 'larasnap';
import { getUrlParam, counter } from 'larasnap/support';

export default {
    mixins: [Common, UsesBindRelations],
    props: {
        data: Object,
    },
    mounted() {
        setTimeout(() => {
            if (getUrlParam('sgn') && counter('sgn').first()) {
                this.data.config.buttons
                    .filter(x => x.type === 'addButton')
                    .forEach(this.buttonClick);
            }
        }, 100);
    },
    methods: {
        buttonClick(button) {
            if (button.type === 'addButton') {
                // Check if the user has specified a specific function to run
                if (this.config.add_button_function) {
                    // If this snapgrid is not contained within a panel then run the
                    // function within the global scope
                    if (!$(this.$refs.wrapper).panel()) {
                        window[this.config.add_button_function]();
                        // Otherwise run the function as a panel class method
                    } else {
                        $(this.$refs.wrapper).panel().runFunction(this.config.add_button_function);
                    }
                    // Otherwise load the panel from the bind relation
                } else {
                    loadPanel({
                        name: this.getBindRelation('Panel'),
                        parent: $(this.$refs.wrapper).panel(),
                        ...button.load_panel_props,
                    });
                }
            } else if (button.type === 'loadPanel') {
                if (button.load_panel_props) {
                    loadPanel({
                        name: button.panel,
                        ...button.load_panel_props,
                    });
                } else {
                    if (!button.params) {
                        button.params = [];
                    } else if (Array.isArray(button.params)) {
                        button.params = [button.params];
                    }

                    loadPanel(button.panel, ...button.params);
                }
            } else if (button.type === 'function') {
                window[button.function](...(button.function_props ?? []));
            }
        },
        menuOptionClicked(option) {
            if (!option.onclick) return;

            const a = option.onclick.split('.');
            const type = a[0];
            const name = a[1];

            if (typeof option.params === 'string') {
                option.params = [option.params];
            } else if (!option.params) {
                option.params = [];
            }

            if (type === 'Panel') {
                loadPanel(name, ...option.params);
            } else if (type === 'function') {
                window[name](...option.params);
            }
        },
    },
};
</script>

<style lang="scss" module></style>
<style lang="scss" module="theme_default" src="./../css/themes/default/button_control.scss"></style>
<style lang="scss" module="theme_simple" src="./../css/themes/simple/button_control.scss"></style>
